import { createReducer, on } from '@ngrx/store';
import { OAuth2CredentialsModel } from '@models/oauth2-credentials.model';
import { OAuth2CredentialsActions } from '@states/oauth2-credentials/oauth2-credentials.action-types';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface OAuth2CredentialsState extends EntityState<OAuth2CredentialsModel.Credential> {
  isLoading: boolean;
  initialLoaded: boolean;
  query: string;
  filters: OAuth2CredentialsModel.Filters;
}

export const adapter: EntityAdapter<OAuth2CredentialsModel.Credential> = createEntityAdapter<OAuth2CredentialsModel.Credential>({
  selectId: (credential: OAuth2CredentialsModel.Credential) => credential.keyId,
});

export const initialState: OAuth2CredentialsState = adapter.getInitialState({
  isLoading: false,
  initialLoaded: false,
  query: null,
  filters: {
    orderBy: 'createdAt',
    orderDirection: 'desc',
  },
});

export const oauth2CredentialsStateReducer = createReducer(
  initialState,
  on(OAuth2CredentialsActions.resetToInitialState, state => {
    return {
      ...initialState,
    };
  }),
  on(OAuth2CredentialsActions.getOAuth2CredentialsSuccess, (state, { credentials }) => {
    return adapter.setAll(credentials, {
      ...state,
      isLoading: false,
      initialLoaded: true,
    });
  }),
  on(OAuth2CredentialsActions.getOAuth2CredentialsFail, (state) => {
    return {
      ...state,
      isLoading: false,
      initialLoaded: true,
    };
  }),
  on(OAuth2CredentialsActions.setIsLoading, (state, { isLoading }) => {
    return {
      ...state,
      isLoading: isLoading,
    };
  }),
  on(OAuth2CredentialsActions.setQuery, (state, { query }) => {
    return {
      ...state,
      query,
    };
  }),
  on(OAuth2CredentialsActions.createOAuth2CredentialSuccess, (state, { response }) => {
    const credential: OAuth2CredentialsModel.Credential = {
      keyId: response.keyId,
      name: response.name,
      scopes: response.scopes,
      createdAt: response.createdAt,
      expiresAt: response.expiresAt,
    };
    return adapter.addOne(credential, state);
  }),
  on(OAuth2CredentialsActions.revokeOAuth2CredentialSuccess, (state, { keyId }) => {
    return adapter.removeOne(keyId, state);
  }),
  on(OAuth2CredentialsActions.resetList, (state) => {
    return adapter.removeAll({
      ...state,
    });
  }),
);
